module.exports = __webpack_public_path__ + "05_2x.jpg?b1bab24a99c686e9da52235839a91743";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/05_2x.jpg
// module id = 16
// module chunks = 0